// Períodos do card animado de juros recebidos. Exemplo ilustrativo: valores
// fictícios — a legenda do card diz isso a quem escuta a página.

export type InterestPeriod = {
  days: number;
  amount: number;
  /** Curva do gráfico, de 0 (base) a 1 (topo); sempre 10 pontos. */
  points: number[];
};

export const INTEREST_PERIODS: InterestPeriod[] = [
  {
    days: 90,
    amount: 8213.89,
    points: [0.3, 0.62, 0.58, 0.6, 0.72, 0.78, 0.6, 0.86, 0.88, 0.86],
  },
  {
    days: 30,
    amount: 2874.3,
    points: [0.2, 0.34, 0.3, 0.42, 0.38, 0.5, 0.46, 0.58, 0.54, 0.62],
  },
  {
    days: 60,
    amount: 5391.12,
    points: [0.26, 0.48, 0.44, 0.56, 0.66, 0.6, 0.52, 0.7, 0.76, 0.74],
  },
];
